import React from 'react';
import { SaleBar } from '@landr/pricing';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import { Box } from '@landr/maestro';

const SaleBarWrapper: React.FC = () => {
    const { isAuthenticated, isLoading } = useAuthentication();

    return (
        <Box zIndex={200}>
            {isLoading ? (
                <></>
            ) : (
                <SaleBar isAuthenticated={!!isAuthenticated} />
            )}
        </Box>
    );
};

export default SaleBarWrapper;
